module.exports = __webpack_public_path__ + "media/images/heart-f2f0f4409406a8c7ae21e89affe3ac0a.jpg";